import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

class CreateLinks extends React.PureComponent {
	render() {
		const { translations } = this.props;

		return (
			<div className="login-links">
				<Link to={"/reviewer/login"}>
					{translations.sections.reviewer_registration_form.back_link}
				</Link>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		translations: state.translations.translations
	};
};

export default connect(mapStateToProps)(CreateLinks);



// WEBPACK FOOTER //
// ./src/components/reviewer/create/CreateLinks.js